// FemiEko subscription page: calculator, selection and add to cart with a selling plan.
// Copy comes from the section ([data-fe-sub-i18n]); prices and plans from [data-fe-sub-data].
if (!customElements.get('fe-subscription')) {
  customElements.define('fe-subscription', class extends HTMLElement {
    connectedCallback() {
      const dataNode = this.querySelector('[data-fe-sub-data]');
      this.form = this.querySelector('[data-fe-sub-form]');
      if (!dataNode || !this.form) return;
      try { this.products = JSON.parse(dataNode.textContent); } catch (e) { return; }
      try { this.t = JSON.parse(this.querySelector('[data-fe-sub-i18n]').textContent); } catch (e) { this.t = {}; }
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.shipping = Number(this.dataset.shipping) || 0;
      this.shippingKnown = this.dataset.shippingKnown === 'true';
      this.setupMoney();
      this.inputs = this.products.map((_, i) => this.querySelector('#q' + i));
      this.fields = this.querySelector('[data-fe-sub-fields]');
      this.status = this.querySelector('[data-fe-status]');
      this.consent = this.querySelector('[data-fe-consent]');
      this.submit = this.querySelector('[data-fe-submit]');
      this.restrictFrequencies();

      this.querySelectorAll('[data-delta]').forEach((b) => b.addEventListener('click', () => {
        const el = this.inputs[Number(b.dataset.index)];
        if (!el) return;
        el.value = Number(el.value) + Number(b.dataset.delta);
        this.update();
      }, { signal }));
      this.inputs.forEach((i) => i && i.addEventListener('change', () => this.update(), { signal }));
      this.querySelectorAll('[name=frequency_ui]').forEach((i) => i.addEventListener('change', () => this.update(), { signal }));
      this.form.addEventListener('submit', (e) => this.onSubmit(e), { signal });
      const sample = this.querySelector('[data-fe-sample-form]');
      if (sample) sample.addEventListener('submit', (e) => this.onSample(e, sample), { signal });
      this.update();
    }

    disconnectedCallback() { this.abort?.abort(); }

    tr(key, vars) {
      let s = this.t[key] || '';
      if (vars) Object.keys(vars).forEach((k) => { s = s.split('{' + k + '}').join(vars[k]); });
      return s;
    }

    // The section renders 123456 cents with the shop's money format; derive prefix, suffix and separators from it.
    setupMoney() {
      const sample = (this.dataset.money || '').trim();
      const m = sample.match(/\d[\d.,\s  ']*\d/);
      this.moneyPrefix = m ? sample.slice(0, m.index) : '';
      this.moneySuffix = m ? sample.slice(m.index + m[0].length) : '';
      const num = m ? m[0] : '1,234.56';
      const dec = num.match(/(\D)(\d{2})$/);
      if (dec && num.replace(/\D/g, '') === '123456') {
        this.decimals = 2;
        this.decSep = dec[1];
        const th = num.slice(0, num.length - 3).match(/^1(\D*)234$/);
        this.thouSep = th ? th[1] : '';
      } else {
        this.decimals = 0;
        this.decSep = '';
        const th = num.match(/^1(\D*)23[45]$/);
        this.thouSep = th ? th[1] : '';
      }
    }

    money(cents) {
      const value = Math.round(cents) / 100;
      const fixed = value.toFixed(this.decimals);
      const [intPart, fracPart] = fixed.split('.');
      const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, this.thouSep);
      return this.moneyPrefix + grouped + (fracPart ? this.decSep + fracPart : '') + this.moneySuffix;
    }

    planFor(product, months) { return product.plans.find((p) => p.months === months); }

    // Only offer intervals that every listed product supports.
    restrictFrequencies() {
      const sets = this.products.map((p) => new Set(p.plans.map((x) => x.months)));
      const common = sets.length ? [...sets[0]].filter((m) => sets.every((s) => s.has(m))) : [];
      this.months = common;
      let firstShown = null;
      this.querySelectorAll('[data-fe-frequency] label').forEach((label) => {
        const ok = common.includes(Number(label.dataset.months));
        label.hidden = !ok;
        if (ok && !firstShown) firstShown = label.querySelector('input');
      });
      const checked = this.querySelector('[name=frequency_ui]:checked');
      if ((!checked || checked.closest('label').hidden) && firstShown) firstShown.checked = true;
    }

    quantities() {
      return this.inputs.map((input) => {
        if (!input) return 0;
        const n = Math.max(0, Math.min(99, Math.floor(Number(input.value) || 0)));
        input.value = n;
        return n;
      });
    }

    update() {
      const chosen = this.querySelector('[name=frequency_ui]:checked');
      const months = chosen ? Number(chosen.value) : 1;
      const q = this.quantities();
      let count = 0, regular = 0, subtotal = 0, missing = false;
      q.forEach((n, i) => {
        if (!n) return;
        const plan = this.planFor(this.products[i], months);
        if (!plan) { missing = true; return; }
        count += n;
        regular += n * this.products[i].price;
        subtotal += n * plan.price;
      });
      const shipping = count && this.shippingKnown ? this.shipping : 0;
      const total = subtotal + shipping;
      const saving = regular - subtotal;
      const set = (k, v) => { const el = this.querySelector('[data-fe-' + k + ']'); if (el) el.textContent = v; };
      set('regular', this.money(regular));
      set('subtotal', this.money(subtotal));
      set('shipping', this.shippingKnown ? this.money(shipping) : this.tr('shipCell'));
      set('total', this.money(total));
      set('mobile-total', this.money(total));
      set('saving', count ? this.tr('saving', { saving: this.money(saving), year: this.money(saving * 12 / months) }) : '');
      set('selected', count ? q.map((n, i) => (n ? n + ' × ' + this.products[i].name : null)).filter(Boolean).join(' · ') : this.tr('empty'));
      const freq = months === 1 ? this.tr('freqOne') : this.tr('freqMany', { n: months });
      set('consent-text', this.tr('consent', { freq, total: this.money(total), ship: this.tr('shipSuffix') }));
      this.submit.disabled = !count || missing;

      this.fields.replaceChildren();
      let j = 0;
      q.forEach((n, i) => {
        if (!n) return;
        const plan = this.planFor(this.products[i], months);
        if (!plan) return;
        for (const [key, value] of Object.entries({ id: this.products[i].id, quantity: n, selling_plan: plan.id })) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'items[' + j + '][' + key + ']';
          input.value = value;
          this.fields.append(input);
        }
        j++;
      });
      if (this.consent) this.consent.checked = false;
      this.message('');
    }

    message(text, isError) {
      if (!this.status) return;
      this.status.textContent = text;
      if (isError) this.status.setAttribute('data-error', ''); else this.status.removeAttribute('data-error');
    }

    items() {
      return [...this.fields.querySelectorAll('input')].reduce((acc, input) => {
        const m = input.name.match(/^items\[(\d+)\]\[(\w+)\]$/);
        if (!m) return acc;
        (acc[Number(m[1])] = acc[Number(m[1])] || {})[m[2]] = Number(input.value);
        return acc;
      }, []);
    }

    async addToCart(items) {
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } }));
      const payload = { items };
      if (sections.length) payload.sections = sections;
      const res = await fetch(this.dataset.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      const result = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(result.description || result.message || this.tr('error'));
      const cart = await fetch(this.dataset.cart, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      cart.sections = result.sections;
      const pubsub = window.FoxTheme && window.FoxTheme.pubsub;
      if (pubsub) pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.show === 'function') drawer.show();
      else window.location.href = this.dataset.cartPage;
    }

    async onSubmit(e) {
      e.preventDefault();
      const items = this.items();
      if (!items.length) { this.message(this.tr('chooseOne'), true); return; }
      const label = this.submit.innerHTML;
      this.submit.disabled = true;
      this.message(this.tr('adding'));
      try {
        await this.addToCart(items);
        this.message(this.tr('added'));
      } catch (err) {
        this.message(err.message, true);
      } finally {
        this.submit.innerHTML = label;
        this.submit.disabled = false;
        if (this.consent) this.consent.checked = false;
      }
    }

    async onSample(e, form) {
      e.preventDefault();
      const btn = form.querySelector('[data-fe-sample-submit]');
      const id = Number(form.querySelector('[name=id]').value);
      const label = btn.innerHTML;
      btn.disabled = true;
      try {
        await this.addToCart([{ id, quantity: 1 }]);
      } catch (err) {
        this.message(err.message, true);
        form.submit();
      } finally {
        btn.innerHTML = label;
        btn.disabled = false;
      }
    }
  });
}
